import { RouteRecordRaw } from 'vue-router';
import { useAppStore } from '@globals/stores/app';
import { useCustomerProfileViewStore } from '@customer/stores/customerProfileView';

// useCustomerProfileViewStore
const publicRoutes: RouteRecordRaw[] = [
	{
		path: '/konto/home',
		name: 'HomePage',
		component: () => import('@globals/components/global/HomePage.vue'),
		beforeEnter(to, from, next) {
			const customerProfileView = useCustomerProfileViewStore();
			const appStore = useAppStore();

			if (customerProfileView.isFormChanged) {
				customerProfileView.isDataShouldSubmit = true;
				appStore.nextRouteNameAttempt = String('HomePage');
				next(false);
				return;
			}

			next();
		},
	},
	{
		path: '/konto/polecanie',
		name: 'RecommendationPage',
		component: () => import('@customer/static-page/RecommendationPage.vue'),
	},
	{
		path: '/konto/promowanie',
		name: 'PromotionPage',
		component: () => import('@customer/static-page/PromotionPage.vue'),
	},
];

export default publicRoutes;
